import {
  batchCarryOverBudgetProjectReport,
  budgetProjectEndItem,
  cancelBudgetProjectReport,
  carryOverBudgetProjectReport,
  carryOverBudgetProjectSettings,
  carryOverBudgetProjectSettingsDetail,
  cleanBudgetProjectReport,
  deleteBudgetProjectReport,
  getBudgetProjectReportAgentDetail,
  getBudgetProjectReportAuditDetail,
  getProjectReportList,
  saveBudgetProjectReport,
  submitBudgetProjectReport,
} from '../services';

export default {
  namespace: 'projectLibrary',
  state: {},
  effects: {
    // 获取预算项目申报列表
    *getProjectReportList({ payload }, { call }) {
      return yield call(getProjectReportList, payload);
    },
    // 获取预算项目申报详情——经办人
    *getBudgetProjectReportAgentDetail({ payload }, { call }) {
      return yield call(getBudgetProjectReportAgentDetail, payload);
    },
    // 获取预算项目申报详情——审批人
    *getBudgetProjectReportAuditDetail({ payload }, { call }) {
      return yield call(getBudgetProjectReportAuditDetail, payload);
    },
    // 保存项目申报
    *saveBudgetProjectReport({ payload }, { call }) {
      return yield call(saveBudgetProjectReport, payload);
    },
    // 清理项目申报
    *cleanBudgetProjectReport({ payload }, { call }) {
      return yield call(cleanBudgetProjectReport, payload);
    },
    // 删除项目申报
    *deleteBudgetProjectReport({ payload }, { call }) {
      return yield call(deleteBudgetProjectReport, payload);
    },
    // 结转项目申报
    *carryOverBudgetProjectReport({ payload }, { call }) {
      return yield call(carryOverBudgetProjectReport, payload);
    },
    // 结转项目申报
    *cancelBudgetProjectReport({ payload }, { call }) {
      return yield call(cancelBudgetProjectReport, payload);
    },
    // 提交项目申报
    *submitBudgetProjectReport({ payload }, { call }) {
      return yield call(submitBudgetProjectReport, payload);
    },
    // 批量结转项目申报单
    *batchCarryOverBudgetProjectReport({ payload }, { call }) {
      return yield call(batchCarryOverBudgetProjectReport, payload);
    },
    // 查询预算项目自动结转设置
    *carryOverBudgetProjectSettingsDetail({ payload }, { call }) {
      return yield call(carryOverBudgetProjectSettingsDetail, payload);
    },
    // 保存预算项目自动结转设置
    *carryOverBudgetProjectSettings({ payload }, { call }) {
      return yield call(carryOverBudgetProjectSettings, payload);
    },
    // 项目结项
    *budgetProjectEndItem({ payload }, { call }) {
      return yield call(budgetProjectEndItem, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
